import { useMutation } from '@tanstack/react-query';

import type { GHLUserTokenResponse } from '~entities/users/hooks';

import { baseAPI } from '~shared/api/base-api';

import { setCurrentUser } from '../model/user-store';

export const decryptUserAPI = async (encryptedUserData: string) => {
  const response = await baseAPI.post<GHLUserTokenResponse>(
    '/auth/decrypt-user',
    {
      encryptedUserData,
    },
  );
  return response.data;
};

export const useDecryptUserMutation = () => {
  return useMutation({
    mutationFn: async (encryptedUserData: string) => {
      const data = await decryptUserAPI(encryptedUserData);
      setCurrentUser(data.user);
      return data;
    },
  });
};

